import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/Master/PackPrintStruct.css';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import axios from 'axios';

const SubUserView = () => {
    const { Id } = useParams();
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const dispatch = useDispatch();
    const componentRef = useRef();
    const [formData, setFormData] = useState({
        ID: '',
        balamt: '',
        billNo: '',
        cgst: '',
        discnt_amt: '',
        discnt_type: '',
        discnt_val: '',
        dt: '',
        freight_ch: '',
        gst: '',
        gst_val: '',
        igst: '',
        netamt: '',
        other_ch: '',
        schlId: '',
        schlNm: '',
        sgst: '',
        totamt: '',
        totissqty: '',
        zoneId: '',
        zoneNm: '',
        firmId: '',
        firmNm: '',
        adrs: '',
        schladrs: "",
        firmph: '',
        fgst: '',
        schlph: '',
        totrate: '',
        sgstper: '',
        cgstper: '',
        igstper: '',
        schlcd: '',
        bankNm: '',
        ifsc: '',
        ac_no: '',
        branchNm: ''
    })
    const [packInfo, setPackInfo] = useState([]);
    const [packData, setPackData] = useState([]);
    const [selectFirmdata, setSelectFirmdata] = useState({});
    useEffect(() => {
        fetchSchlUsers(Id);
    }, [Id, dispatch]);



    const fetchSchlUsers = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getUserPageReg&suId=${id}`);
            const memos = response?.data?.info;
            setPackInfo(memos);
            setPackData(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };
    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };



    // console.log(packData);


    return (

        <Grid item xs={12}>
            <Paper>
                <div ref={componentRef} style={{ padding: '1%' }}>
                    {/* Heading */}
                    <h3 className='centered-heading'>User Pages Assign View</h3>
                    <div className="dashed-line"></div>

                    <table style={{ margin: '1% 5%' }}>

                        <tbody>

                            <tr>
                                <td style={{ width: '200px' }}>Name :</td>
                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{packData?.uname}</td>
                                <td style={{ width: '200px', paddingLeft: '2%' }}>User Name :</td>
                                <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{packData?.userNm}</td>
                            </tr>
                            <tr>
                                <td style={{ width: '200px' }}>Contact :</td>
                                <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{packData?.ph}</td>
                                <td style={{ width: '200px', paddingLeft: '2%' }}>Password :</td>
                                <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{packData?.pass}</td>
                            </tr>
                        </tbody>

                    </table>
                    {/* Main Table */}
                    {/* {packInfo.length > 0 &&

                        <table className="main-table">
                            <thead>
                                <tr>
                                    <th>SR NO.</th>
                                    <th>School</th>
                                    <th>Code</th>
                                    <th>Pages Assign</th>
                                </tr>
                            </thead>
                            <tbody>
                                {packInfo.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.schlNm}</td>
                                        <td>{item.schlcd}</td>
                                        <td>
                                            {item?.pages_info?.map((name, idx) => (
                                                <span key={idx}>
                                                    {name?.pages}
                                                    {idx !== item?.pages_info?.length - 1 && <br />}
                                                </span>
                                            ))}
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </table>
                    } */}

                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                        <Table>
                            <TableHead>
                                <TableRow className='tbl-row'>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>School</TableCell>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Code</TableCell>
                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Page Assign</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {packInfo.map((form, index) => (
                                    <TableRow key={index}>
                                        
                                        <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.schlNm}</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.schlcd}</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                            {/* {form.pageNmList.join(', ')} */}

                                            {form.pages_info.map((name, idx) => (
                                                <span key={idx}>
                                                    {name.pages}
                                                    {idx !== form.pages_info.length - 1 && <br />}
                                                </span>
                                            ))}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                </div>


            </Paper>
        </Grid>
    );
};

export default SubUserView;
